const Transportation = () => {
    return (
      <div>
      
      <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pr-[2rem] pt-[1rem] mb-[100px]">
        <h1 className="text-[20px] font-bold">Transportation</h1>
        <p>
          TCS is able to execute projects involving heavy, bulky, and out-of-gauge loads with the help 
          of special transport equipment. We devise multi-modal cargo transportation plans based on the customer’s 
          specific needs. We take into consideration the criteria such as transit times, cargo specifications, 
          departure and arrival destination to offer customers the most suitable road, air, maritime, railway, 
          and inter-modal transportation options.
        </p>
       
  
       
      </div>
    </div>  
    );
  };
    
  export default Transportation;